import Image from 'next/image';

type ToolHeroProps = {
	eyebrow: string;
	title: string;
	subtitle?: string;
};

export function ToolHero({ eyebrow, title, subtitle }: ToolHeroProps): JSX.Element {
	return (
		<header className="relative overflow-hidden bg-gradient-to-br from-[#2f1b4e] to-[#241541] text-white">
			<div
				aria-hidden
				className="pointer-events-none absolute -right-32 -top-32 h-[420px] w-[420px] rounded-full bg-[radial-gradient(circle,rgba(244,117,36,0.22),transparent_70%)]"
			/>
			<div className="mx-auto flex max-w-7xl items-center justify-between gap-8 px-4 py-12 sm:px-6 lg:px-8">
				<div className="relative z-10">
					<p className="font-mono text-[11px] font-bold uppercase tracking-[0.14em] text-orange-400">
						{eyebrow}
					</p>
					<h1 className="mt-3 max-w-[24ch] font-space-grotesk text-3xl font-extrabold tracking-tight sm:text-4xl">
						{title}
					</h1>
					{subtitle ? (
						<p className="mt-3 max-w-2xl text-[15.5px] text-purple-100">{subtitle}</p>
					) : null}
				</div>
				<div className="relative z-10 hidden shrink-0 md:block">
					<Image
						src="/tools/_shared/assets/jcw-logo-transparent.png"
						alt="JovianCloudWorks"
						width={205}
						height={184}
						className="h-[150px] w-auto drop-shadow-[0_6px_20px_rgba(0,0,0,0.35)] lg:h-[168px]"
						priority
					/>
				</div>
			</div>
		</header>
	);
}
